webpackJsonp([1],{

/***/ "FVn7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//

/* harmony default export */ var App = ({
  name: 'app'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36742a97","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("bM3y")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/vue-range-slider/dist/vue-range-slider.cjs.js
var vue_range_slider_cjs = __webpack_require__("G4W2");
var vue_range_slider_cjs_default = /*#__PURE__*/__webpack_require__.n(vue_range_slider_cjs);

// CONCATENATED MODULE: ./src/directives/animatedIncrementingNumbers.js


/* harmony default export */ var animatedIncrementingNumbers = (vue_esm["a" /* default */].directive('animatedIncrementingNumbers', {
  twoWay: true,

  inserted: function inserted(el, binding, vnode) {
    vnode.context.userData[binding.value.varName] = binding.value.minValue || 0;

    setTimeout(function () {
      binding.value.interval = window.setInterval(function () {
        if (vnode.context.userData[binding.value.varName] < binding.value.valToAnimateTo) {
          var change = (binding.value.valToAnimateTo - vnode.context.userData[binding.value.varName]) / binding.value.changeDiv;
          change = change >= 0 ? Math.ceil(change) : Math.floor(change);
          // vnode.context.userData[binding.value.varName] =Math.min(vnode.context.userData[binding.value.varName] + binding.value.increment, binding.value.valToAnimateTo);
          vnode.context.userData[binding.value.varName] = vnode.context.userData[binding.value.varName] + change;
        } else {
          clearInterval(binding.value.interval);
          vnode.context.animationsCompleted++;
        }
      }, binding.value.timeInterval);
    }, 400);
  }
}));
// EXTERNAL MODULE: ./node_modules/vue-range-slider/dist/vue-range-slider.css
var vue_range_slider = __webpack_require__("Z7gM");
var vue_range_slider_default = /*#__PURE__*/__webpack_require__.n(vue_range_slider);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Main = ({
  name: 'Main',
  watch: {
    'userData.phevPetrolCost': function userDataPhevPetrolCost() {
      this.userDataChanged('phevPetrolCost', this.regionData.units.currency + '/' + this.regionData.units.fuelVolume);
    },
    'userData.phevElectricityCost': function userDataPhevElectricityCost() {
      this.userDataChanged('phevElectricityCost', this.regionData.units.currency + '/' + this.regionData.units.electricity);
    },
    'userData.currentFuelCost': function userDataCurrentFuelCost() {
      this.userDataChanged('currentFuelCost', this.regionData.units.currency + '/' + this.regionData.units.fuelVolume);
    },
    'userData.currentFuelEconomy': function userDataCurrentFuelEconomy() {
      this.userDataChanged('currentFuelEconomy', this.regionData.units.fuelEconomy);
    },
    'userData.distanceTravelledWeekday': function userDataDistanceTravelledWeekday() {
      if (this.animationComplete) {
        this.userDataChanged('distanceTravelledWeekday', this.regionData.units.distance);
      }
    },
    'userData.distanceTravelledWeekend': function userDataDistanceTravelledWeekend() {
      if (this.animationComplete) {
        this.userDataChanged('distanceTravelledWeekend', this.regionData.units.distance);
      }
    }

  },
  filters: {
    roundToTwo: function roundToTwo(value, stepSize) {
      if (stepSize !== undefined) {
        if (stepSize % 1 !== 0) {
          return value.toFixed(2);
        } else {
          return value;
        }
      }
      return value.toFixed(2);
    }
  },
  directives: {
    animatedIncrementingNumbers: animatedIncrementingNumbers
  },
  components: {
    RangeSlider: vue_range_slider_cjs_default.a
  },
  computed: {
    animationComplete: function animationComplete() {
      return this.animationsCompleted === this.totalAnimations;
    },
    oneWeekSavings: function oneWeekSavings() {
      // convert distances to MILES
      var distanceTravelledWeekday = this.userData.distanceTravelledWeekday;
      var distanceTravelledWeekend = this.userData.distanceTravelledWeekend;
      var phevElectricRange = this.regionData.constants.phevElectricRange;
      if (this.regionData.units.distance.toLowerCase() === "km") {
        distanceTravelledWeekday = this.convertKmToMiles(distanceTravelledWeekday);
        distanceTravelledWeekend = this.convertKmToMiles(distanceTravelledWeekend);
        phevElectricRange = this.convertKmToMiles(phevElectricRange);
      }
      // convert fuel economy to MPG
      var currentFuelEconomy = this.userData.currentFuelEconomy;
      var phevFuelEconomy = this.regionData.constants.phevFuelEconomy;
      if (this.regionData.units.fuelEconomy.toLowerCase() !== "mpg") {
        currentFuelEconomy = this.convertLP100ToMPG(currentFuelEconomy);
        phevFuelEconomy = this.convertLP100ToMPG(phevFuelEconomy);
      }
      // convert fuel cost to /G
      var currentFuelCost = this.userData.currentFuelCost;
      var phevPetrolCost = this.userData.phevPetrolCost;
      if (this.regionData.units.fuelVolume.toLowerCase() === "l") {
        currentFuelCost = this.convertCostPLToPG(currentFuelCost);
        phevPetrolCost = this.convertCostPLToPG(phevPetrolCost);
      }
      // current cost
      var currentVehicleCostWeekday = distanceTravelledWeekday / currentFuelEconomy * currentFuelCost;
      var currentVehicleCostWeekend = distanceTravelledWeekend / currentFuelEconomy * currentFuelCost;
      var currentCostForWeek = currentVehicleCostWeekday * 5 + currentVehicleCostWeekend * 2;
      // phev electricity cost
      var phevElecDistanceWeekday = Math.min(distanceTravelledWeekday, phevElectricRange);
      var phevElecDistanceWeekend = Math.min(distanceTravelledWeekend, phevElectricRange);
      var phevElecCostForWeek = this.regionData.constants.phevElectricEconomy * this.userData.phevElectricityCost * (phevElecDistanceWeekday * 5 + phevElecDistanceWeekend * 2);
      // phev petrol cost
      var phevPetrolCostForWeek = 0;
      if (distanceTravelledWeekday > phevElectricRange) {
        phevPetrolCostForWeek += (distanceTravelledWeekday - phevElectricRange) / phevFuelEconomy * phevPetrolCost * 5;
      }
      if (distanceTravelledWeekend > phevElectricRange) {
        phevPetrolCostForWeek += (distanceTravelledWeekend - phevElectricRange) / phevFuelEconomy * phevPetrolCost * 2;
      }
      var phevTotalCostForWeek = phevPetrolCostForWeek + phevElecCostForWeek;
      return Math.max(currentCostForWeek - phevTotalCostForWeek, 0);
    },
    oneMonthSavings: function oneMonthSavings() {
      return Math.floor(this.oneWeekSavings * 4);
    },
    oneYearSavings: function oneYearSavings() {
      return Math.floor(this.oneWeekSavings * 52);
    },
    threeYearSavings: function threeYearSavings() {
      return Math.floor(this.oneWeekSavings * 156);
    }
  },
  methods: {
    debounce: function debounce(func, wait, immediate) {
      // test
      var timeout;
      return function () {
        var context = this;
        var args = arguments;
        var later = function later() {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    },
    convertKmToMiles: function convertKmToMiles(distanceInKm) {
      return distanceInKm * this.KM_TO_MILE_MULT;
    },
    convertLP100ToMPG: function convertLP100ToMPG(economyInLP100) {
      // imperial gallon
      return this.LP100_TO_MPG_MULT / economyInLP100;
    },
    convertCostPLToPG: function convertCostPLToPG(costPL) {
      return costPL / this.LITRE_TO_GALLON_MULT;
    },

    loadDoc: function loadDoc() {
      var xhttp = new XMLHttpRequest();
      var self = this;
      xhttp.onreadystatechange = function () {
        if (this.readyState === 4 && this.status === 200) {
          self.regionData = JSON.parse(this.responseText);
          self.loaded = true;
          console.log('data loaded');
          self.reset();
        }
      };
      xhttp.open("GET", "./static/data.json", true);
      xhttp.send();
    },
    goToTestDrive: function goToTestDrive() {
      window.open(this.regionData.textLabels.bookATestDriveUrl, '_blank');
    },
    reset: function reset() {
      this.userData = this.getInitialUserData();
    },
    getInitialUserData: function getInitialUserData() {
      return {
        currentFuelEconomy: this.regionData.sliders.currentVehicleFuelEconomy.default,
        distanceTravelledWeekday: this.regionData.sliders.distanceTravelledWeekday.default,
        distanceTravelledWeekend: this.regionData.sliders.distanceTravelledWeekend.default,
        currentFuelCost: this.regionData.sliders.currentVehicleFuelCost.default,
        phevPetrolCost: this.regionData.sliders.phevPetrolCost.default,
        phevElectricityCost: this.regionData.sliders.phevElectricityCost.default
      };
    },
    onScroll: function onScroll(e) {
      var scrollTop = 0;
      if (document.scrollingElement) {
        scrollTop = document.scrollingElement.scrollTop;
      } else {
        // IE
        scrollTop = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;
      }
      if (scrollTop > this.SCROLL_BEFORE_FIXING && !this.$el.classList.contains(this.FIX_HEADER_CLASS)) {
        this.$el.classList.add(this.FIX_HEADER_CLASS);
      } else if (scrollTop <= this.SCROLL_BEFORE_FIXING && this.$el.classList.contains(this.FIX_HEADER_CLASS)) {
        this.$el.classList.remove(this.FIX_HEADER_CLASS);
      }
    }
  },
  mounted: function mounted() {
    this.loadDoc();
    if (!window.dataLayer) {
      window.dataLayer = [];
    }
    this.userDataChanged = this.debounce(function (val, unit) {
      if (this.animationsCompleted) {
        window.dataLayer.push({
          "event": "sliderInteraction",
          "sliderType": val,
          "sliderValue": this.userData[val],
          "sliderUnit": unit,
          "threeYearSavings": this.threeYearSavings,
          "threeYearSavingsUnit": this.regionData.units.currency
        });
      }
    }, 250).bind(this);
    window.document.body.onscroll = this.onScroll;
  },
  beforeDestroy: function beforeDestroy() {
    window.document.removeEventListener('scroll', this.onScroll);
  },
  data: function data() {
    return {
      loaded: false,
      regionData: {},
      // constants
      // UNIT_DISTANCE: "miles",
      GALLON_TO_LITRE_MULT: 4.54609,
      KM_TO_MILE_MULT: 1.0 / 1.60934,
      LP100_TO_MPG_MULT: 282.48,
      LITRE_TO_GALLON_MULT: 0.219969,
      SCROLL_BEFORE_FIXING: 215,
      FIX_HEADER_CLASS: 'fix-header',

      userData: {},
      totalAnimations: 2,
      animationsCompleted: 0
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a92be270","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main.vue
var Main_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"sidebar"},[_c('header',{staticClass:"header px-4"},[_c('img',{staticClass:"logo",attrs:{"src":_vm.regionData.logoImage}}),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.regionData.textLabels.headingSmall))]),_vm._v(" "),_c('h1',{staticClass:"mb-5-md"},[_vm._v(_vm._s(_vm.regionData.textLabels.headingLarge)+"\n    ")])])]),_vm._v(" "),_c('section',{staticClass:"side-results bg-black py-1 ml-0"},[_c('div',{staticClass:"result p-2"},[_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.regionData.textLabels.threeYearSavings))]),_vm._v(" "),_c('p',{staticClass:"number mb-1"},[_c('sup',{staticClass:"currency"},[_vm._v(_vm._s(_vm.regionData.units.currency))]),_vm._v(_vm._s(_vm.threeYearSavings)+"\n      ")]),_vm._v(" "),_c('hr',{staticClass:"thin-line"}),_vm._v(" "),_c('p',{staticClass:"text"},[_c('span',[_vm._v(_vm._s(_vm.regionData.textLabels.oneYear))]),_vm._v(" "),_c('span',{staticClass:"mr-2 savings"},[_c('sup',{staticClass:"currency"},[_vm._v(_vm._s(_vm.regionData.units.currency))]),_vm._v(_vm._s(_vm.oneYearSavings))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.regionData.textLabels.oneMonth))]),_vm._v(" "),_c('span',{staticClass:"savings"},[_c('sup',{staticClass:"currency"},[_vm._v(_vm._s(_vm.regionData.units.currency))]),_vm._v(_vm._s(_vm.oneMonthSavings))])])])]),_vm._v(" "),_c('section',{staticClass:"distance-weekday m-3"},[_c('div',{},[_c('button',{staticClass:"btn-sm",on:{"click":_vm.reset}},[_c('div',[_c('img',{staticClass:"icon",attrs:{"src":"static/reset.svg"}}),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.regionData.textLabels.resetButtonText))])])]),_vm._v(" "),_c('h3',{staticClass:"section-heading mt-3"},[_vm._v(_vm._s(_vm.regionData.textLabels.distanceTravelledHeading))])]),_vm._v(" "),_c('div',{staticClass:"weekday-landscape"},[_c('h6',{staticClass:"category"},[_vm._v(_vm._s(_vm.regionData.textLabels.weekday))]),_vm._v(" "),_c('p',{directives:[{name:"animated-incrementing-numbers",rawName:"v-animated-incrementing-numbers",value:({valToAnimateTo: _vm.userData.distanceTravelledWeekday, varName: 'distanceTravelledWeekday', timeInterval: 20, changeDiv: 20}),expression:"{valToAnimateTo: userData.distanceTravelledWeekday, varName: 'distanceTravelledWeekday', timeInterval: 20, changeDiv: 20}"}],staticClass:"number"},[_vm._v(_vm._s(_vm.userData.distanceTravelledWeekday)),_c('sup',{staticClass:"unit"},[_vm._v(" "+_vm._s(_vm.regionData.units.distance))])]),_vm._v(" "),_c('range-slider',{staticClass:"red mt-4 shorter-desktop",attrs:{"min":_vm.regionData.sliders.distanceTravelledWeekday.min,"max":_vm.regionData.sliders.distanceTravelledWeekday.max},model:{value:(_vm.userData.distanceTravelledWeekday),callback:function ($$v) {_vm.$set(_vm.userData, "distanceTravelledWeekday", $$v)},expression:"userData.distanceTravelledWeekday"}})],1)]),_vm._v(" "),_c('section',{staticClass:"distance-weekend m-3"},[_c('div',{staticClass:"weekend-landscape"},[_c('h6',{staticClass:"category"},[_vm._v(_vm._s(_vm.regionData.textLabels.weekend))]),_vm._v(" "),_c('p',{directives:[{name:"animated-incrementing-numbers",rawName:"v-animated-incrementing-numbers",value:({valToAnimateTo: _vm.userData.distanceTravelledWeekend, varName: 'distanceTravelledWeekend', timeInterval: 25, changeDiv: 10}),expression:"{valToAnimateTo: userData.distanceTravelledWeekend, varName: 'distanceTravelledWeekend', timeInterval: 25, changeDiv: 10}"}],staticClass:"number"},[_vm._v(_vm._s(_vm.userData.distanceTravelledWeekend)),_c('sup',{staticClass:"unit"},[_vm._v(" "+_vm._s(_vm.regionData.units.distance))])]),_vm._v(" "),_c('range-slider',{staticClass:"red mt-4",attrs:{"min":_vm.regionData.sliders.distanceTravelledWeekend.min,"max":_vm.regionData.sliders.distanceTravelledWeekend.max},model:{value:(_vm.userData.distanceTravelledWeekend),callback:function ($$v) {_vm.$set(_vm.userData, "distanceTravelledWeekend", $$v)},expression:"userData.distanceTravelledWeekend"}})],1)]),_vm._v(" "),_c('div',{staticClass:"main-current bg-grey p-3 pt-4"},[_c('h3',{staticClass:"section-heading"},[_vm._v(_vm._s(_vm.regionData.textLabels.currentVehicleHeading))]),_vm._v(" "),_c('h6',{staticClass:"category"},[_vm._v(_vm._s(_vm.regionData.textLabels.currentVehicleFuelEconomy))]),_vm._v(" "),_c('p',{staticClass:"number"},[_vm._v(_vm._s(_vm._f("roundToTwo")(_vm.userData.currentFuelEconomy,_vm.regionData.sliders.currentVehicleFuelEconomy.stepSize))),_c('sup',{staticClass:"unit"},[_vm._v(_vm._s(_vm.regionData.units.fuelEconomy)+" ")])]),_vm._v(" "),_c('range-slider',{staticClass:"blue mt-3",attrs:{"step":_vm.regionData.sliders.currentVehicleFuelEconomy.stepSize,"min":_vm.regionData.sliders.currentVehicleFuelEconomy.min,"max":_vm.regionData.sliders.currentVehicleFuelEconomy.max},model:{value:(_vm.userData.currentFuelEconomy),callback:function ($$v) {_vm.$set(_vm.userData, "currentFuelEconomy", $$v)},expression:"userData.currentFuelEconomy"}}),_vm._v(" "),_c('h6',{staticClass:"category"},[_vm._v(_vm._s(_vm.regionData.textLabels.currentVehicleFuelCost)+"\n    ")]),_vm._v(" "),_c('p',{staticClass:"number"},[_c('sup',{staticClass:"currency"},[_vm._v(_vm._s(_vm.regionData.units.currency))]),_vm._v(_vm._s(_vm._f("roundToTwo")(_vm.userData.currentFuelCost,_vm.regionData.sliders.currentVehicleFuelCost.stepSize))),_c('sup',{staticClass:"unit"},[_vm._v("/"+_vm._s(_vm.regionData.units.fuelVolume))])]),_vm._v(" "),_c('range-slider',{staticClass:"blue mt-3",attrs:{"step":_vm.regionData.sliders.currentVehicleFuelCost.stepSize,"min":_vm.regionData.sliders.currentVehicleFuelCost.min,"max":_vm.regionData.sliders.currentVehicleFuelCost.max},model:{value:(_vm.userData.currentFuelCost),callback:function ($$v) {_vm.$set(_vm.userData, "currentFuelCost", $$v)},expression:"userData.currentFuelCost"}})],1),_vm._v(" "),_c('div',{staticClass:"main-phev bg-med-grey p-3 pt-4"},[_c('h3',{staticClass:"section-heading"},[_vm._v(_vm._s(_vm.regionData.textLabels.phevVehicleHeading))]),_vm._v(" "),_c('div',{staticClass:"mb-4"},[_c('div',{},[_c('h6',{staticClass:"category"},[_vm._v(_vm._s(_vm.regionData.textLabels.phevFuelEconomy))]),_vm._v(" "),_c('p',{staticClass:"number"},[_vm._v("\n         "+_vm._s(_vm.regionData.constants.phevFuelEconomy)),_c('sup',{staticClass:"unit"},[_vm._v(_vm._s(_vm.regionData.units.fuelEconomy))])])]),_vm._v(" "),_c('div',{},[_c('h6',{staticClass:"category"},[_vm._v(_vm._s(_vm.regionData.textLabels.phevElectricRange))]),_vm._v(" "),_c('p',{staticClass:"number"},[_vm._v(_vm._s(_vm.regionData.constants.phevElectricRange)),_c('sup',{staticClass:"unit"},[_vm._v(_vm._s(_vm.regionData.units.distance))])])])]),_vm._v(" "),_c('div',{staticClass:"row "},[_c('div',{staticClass:"mt-3"},[_c('h6',{staticClass:"category"},[_vm._v(_vm._s(_vm.regionData.textLabels.phevFuelCost))]),_vm._v(" "),_c('p',{staticClass:"number"},[_c('sup',{staticClass:"currency"},[_vm._v(_vm._s(_vm.regionData.units.currency))]),_vm._v(_vm._s(_vm._f("roundToTwo")(_vm.userData.phevPetrolCost,_vm.regionData.sliders.phevPetrolCost.stepSize))),_c('sup',{staticClass:"unit"},[_vm._v("/"+_vm._s(_vm.regionData.units.fuelVolume))])]),_vm._v(" "),_c('range-slider',{staticClass:"mediumGrey blue mt-3",attrs:{"step":_vm.regionData.sliders.phevPetrolCost.stepSize,"min":_vm.regionData.sliders.phevPetrolCost.min,"max":_vm.regionData.sliders.phevPetrolCost.max},model:{value:(_vm.userData.phevPetrolCost),callback:function ($$v) {_vm.$set(_vm.userData, "phevPetrolCost", $$v)},expression:"userData.phevPetrolCost"}})],1),_vm._v(" "),_c('div',{},[_c('h6',{staticClass:"category"},[_vm._v(_vm._s(_vm.regionData.textLabels.phevElectricityCost))]),_vm._v(" "),_c('p',{staticClass:"number"},[_c('sup',{staticClass:"currency"},[_vm._v(_vm._s(_vm.regionData.units.currency))]),_vm._v(_vm._s(_vm._f("roundToTwo")(_vm.userData.phevElectricityCost,_vm.regionData.sliders.phevElectricityCost.stepSize))),_c('sup',{staticClass:"unit"},[_vm._v("/"+_vm._s(_vm.regionData.units.electricity))])]),_vm._v(" "),_c('range-slider',{staticClass:"mediumGrey blue mt-3",attrs:{"step":_vm.regionData.sliders.phevElectricityCost.stepSize,"min":_vm.regionData.sliders.phevElectricityCost.min,"max":_vm.regionData.sliders.phevElectricityCost.max},model:{value:(_vm.userData.phevElectricityCost),callback:function ($$v) {_vm.$set(_vm.userData, "phevElectricityCost", $$v)},expression:"userData.phevElectricityCost"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"footer-btn p-3"},[_c('button',{staticClass:"btn",attrs:{"data-event":"test-drive"},on:{"click":_vm.goToTestDrive}},[_vm._v(_vm._s(_vm.regionData.textLabels.bookATestDriveText))])]),_vm._v(" "),_c('div',{staticClass:"footer-disclaimer disclaimer p-3"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.regionData.textLabels.disclaimer)}})])]):_vm._e()}
var Main_staticRenderFns = []
var Main_esExports = { render: Main_render, staticRenderFns: Main_staticRenderFns }
/* harmony default export */ var components_Main = (Main_esExports);
// CONCATENATED MODULE: ./src/components/Main.vue
function Main_injectStyle (ssrContext) {
  __webpack_require__("FVn7")
  __webpack_require__("Nn/r")
  __webpack_require__("jVPN")
}
var Main_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Main___vue_template_functional__ = false
/* styles */
var Main___vue_styles__ = Main_injectStyle
/* scopeId */
var Main___vue_scopeId__ = "data-v-a92be270"
/* moduleIdentifier (server only) */
var Main___vue_module_identifier__ = null
var Main_Component = Main_normalizeComponent(
  Main,
  components_Main,
  Main___vue_template_functional__,
  Main___vue_styles__,
  Main___vue_scopeId__,
  Main___vue_module_identifier__
)

/* harmony default export */ var src_components_Main = (Main_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js




vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Main',
    component: src_components_Main
  }]
}));
// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




vue_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  router: router,
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "Nn/r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z7gM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bM3y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jVPN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.025b58eba5ffd24bf7a6.js